export default __webpack_public_path__ + "74e948d87fb028744aa8c4c0c125d851.png";